export const isPrerender = (): boolean => {
  if (typeof navigator === "undefined") return false;
  return navigator.userAgent === "ReactSnap";
};
